import axios from "axios";

export default {
  namespaced: true,
  state: {
    locations: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    locationsMessage: ''
  },
  mutations: {
    CLEAR_DATA(state) {
      state.locations = [];
    },
    RECEIVED_LOCATIONS(state, payload) {
      state.locations = payload;
      state.isReceiving = false;
    },
    RECEIVING_LOCATIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_LOCATION(state, payload) {
      state = Object.assign(state, {
        locations: [...state.locations, payload],
        isReceiving: false,
      })
    },
    RECEIVING_LOCATION(state) {
      state.isReceiving = true;
    },
    UPDATED_LOCATION(state, payload) {
      let index = state.locations.findIndex(location => location._id === payload._id);
      state = Object.assign(state, {
        locations: state.locations.map((location, i) => {
          if (i === index) {
            return Object.assign({}, location, payload);
          }
          return location;
        }),
        isUpdating: false,
        locationsMessage: 'Locations has been updating!',
      })
    },
    UPDATING_LOCATION(state) {
      state.isUpdating = true;
    },
    DELETED_LOCATION(state, payload) {
      let indexToDelete = state.locations.findIndex(location => location._id === payload._id);
      let locations = [...state.locations];
      locations.splice(indexToDelete, 1);
      state = Object.assign(state, {
        locations: [...locations],
        isDeleting: false,
        idToDelete: null,
        locationsMessage: 'Location has been Deleted!',
      });
    },
    DELETING_LOCATION(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getLocationsRequest({dispatch}) {
      dispatch("receivingLocations");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/locations';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "GET", url: url, headers: headers})
      .then(res => {
        dispatch("receiveLocations", res.data);
      })
    },
    async updateLocationRequest({dispatch}, payload) {
      dispatch("updatingLocation");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/location/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "PUT",url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateLocation", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updateLocationImageRequest({dispatch}, payload) {
      dispatch("updatingLocation");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];

      var url = 'https://api.accountxc.com:3100/update/location/image/' + id;
      let data = new FormData();
      data.append('image', payload.locationimage, payload.imagename); 
      delete payload['locationimage'];
      for (let x in payload) {data.append(x, payload[x]);}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      axios({method: "PUT", url: url,headers: headers,data: data})
      .then(function (res) {
        dispatch("updateLocation", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async createLocationRequest({dispatch}, payload) {
      dispatch("receivingLocations");
      let url;
      let data;
      let token = localStorage.getItem('token');
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      if(payload.locationimage) {
        url = 'https://api.accountxc.com:3100/insert/location/withimage';
        data = new FormData();
        data.append('image', payload.locationimage, payload.imagename); 
        delete payload['locationimage'];
        for (let x in payload) {data.append(x, payload[x]);}
      } else {
        url = 'https://api.accountxc.com:3100/insert/location';
        data = payload;
      }
      return axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveLocation", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    deleteLocationRequest({dispatch}, payload) {
      dispatch("deletingLocation", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/location/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deleteLocation", {_id: payload._id});
      })
    },
    clearLocations({commit}){
      commit("CLEAR_DATA")
    },
    receiveLocations({commit}, payload) {
      commit("RECEIVED_LOCATIONS", payload)
    },
    receivingLocations({commit}) {
      commit("RECEIVING_LOCATIONS")
    },
    receiveLocation({commit}, payload) {
      commit("RECEIVED_LOCATION", payload)
    },
    receivingLocation({commit}) {
      commit("RECEIVING_LOCATION")
    },
    updateLocation({commit}, payload) {
      commit("UPDATED_LOCATION", payload)
    },
    updatingLocation({commit}) {
      commit("UPDATING_LOCATION")
    },
    deleteLocation({commit}, payload) {
      commit("DELETED_LOCATION", payload)
    },
    deletingLocation({commit}, payload) {
      commit("DELETING_LOCATION", payload)
    }
  },
};
